import { ICertificationCode } from 'types/FMSGraphqlTypes'

export const REQUIRED_MESSAGE = 'This field is required'

export const TEST_IDS = {
  // Certifications Modal
  certificationModal: 'certification-modal',
  certificationTitleSelect: 'certification-title-select',
  certificationDeleteButton: 'certification-delete-button',
}

export const CERTIFICATION_CODE_LABELS: Record<string, string> = {
  [ICertificationCode.dbe]: 'Disadvantaged Business',
  [ICertificationCode.disabled]: 'Disabled Owned',
  [ICertificationCode.edwosb]: 'Economically Disadvantaged WOSB',
  [ICertificationCode.mbe]: 'Minority-Owned',
  [ICertificationCode.vet]: 'Veteran-Owned',
  [ICertificationCode.wbe]: 'Women-Owned',
  [ICertificationCode.wosb]: 'Women-Owned Small Business',
  [ICertificationCode.small]: 'Small Business',
  [ICertificationCode.sdvet]: 'Service-Disabled Veteran-Owned Small Business',
  [ICertificationCode.sdb]: 'Small Disadvantaged Business',
  [ICertificationCode.lgbt]: 'Lesbian, Gay, Bisexual, and Transgender',
  [ICertificationCode.hbcu]: 'Historically Black Colleges and Universities',
  [ICertificationCode.eight_a]: '8(a) business development program',
  [ICertificationCode.anc_indian_tribe]: 'Alaska Native Corporation or Indian Tribe',
}
